import * as Scrivito from "scrivito";
import metadataAttributes from "objs/_metadataAttributes";
import defaultPageAttributes from "objs/_defaultPageAttributes";

const WizardList = Scrivito.provideObjClass("WizardList", {
  attributes: {
    title: "string",
    subtitle: "string",
    wizardItem: ["referencelist", { only: "WizardItem" }],
    ...metadataAttributes,
    ...defaultPageAttributes,
  },
  extractTextAttributes: ["title", "subtitle"],
});

export default WizardList;
